<template>
  <div class="message-bubble" ref="messageBubble">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'messageBubble',
  props: {
    color: {
      type: String,
      default: '#FFFFFF'
    }
  },
  mounted () {
    this.$refs.messageBubble.style['background-color'] = this.color
  }
}
</script>

<style>
.message-bubble {
  background-color: #ebeef5;
  border-radius: 8px;
  padding: 12px 16px;
  word-break: break-all;
  font-size: 14px;
  display: inline-block;
}

@media (max-width: 1024px) and (min-width: 768px) {
  .message-bubble {
    padding: 5px 8px;
    font-size: .28rem;

  }
}
</style>
